// Module
var code = " <mat-toolbar> <h3>{{'lbl_var_approved_not_claimed' | translate}}</h3> </mat-toolbar> <gh-grid class=\"flex-1\" [definition]=\"gridDefinition\" [data]=\"changeOrders\" ghGridSelectable=\"\" [ghGridSelectableDisabled]=\"isViewMode\" [selectionModel]=\"selected\" (selectionModelChange)=\"select.emit($event)\"></gh-grid> ";
// Exports
module.exports = code;